export default __webpack_public_path__ + "static/media/05.7fec4e25.jpg";